<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<section aria-describedby="menu-content" aria-labelledby="menu-heading" aria-modal="true"
         class="slds-modal slds-fade-in-open slds-modal_large slds-app-launcher"
         role="dialog" tabindex="-1">
  <div class="slds-modal__container">
    <header class="slds-modal__header slds-grid slds-grid_align-spread slds-grid_vertical-align-center">
      <button (click)="onCloseClick()" class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
              title="Close">
        <svg aria-hidden="true" class="slds-button__icon slds-button__icon_large">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
        </svg>
        <span class="slds-assistive-text">Close</span>
      </button>

      <h2 class="slds-text-heading_medium" id="menu-heading">Menu</h2>
      <div class="slds-app-launcher__header-search">
        <div class="slds-form-element">
          <label class="slds-form-element__label slds-assistive-text" for="app-launcher-search">Find an app</label>
          <div class="slds-form-element__control slds-input-has-icon slds-input-has-icon_left">
            <svg aria-hidden="true" class="slds-input__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#search"></use>
            </svg>
            <input class="slds-input" id="app-launcher-search" placeholder="Find" type="search"/>
          </div>
        </div>
      </div>
    </header>

    <div class="slds-modal__content slds-app-launcher__content slds-p-around_small"
         id="menu-content">
      <ul class="slds-grid slds-wrap" id="menu-items">

        <li *ngFor="let mi of menuItems"
            class="slds-col_padded slds-p-vertical_x-small"
            style="min-width: 10rem">
          <a (click)="onMenuClick(mi)"
             [title]="mi.description"
             class="slds-truncate">
            <img *ngIf="mi.iconHref?.endsWith('.svg')"
                 [src]="mi.iconHref"
                 [alt]="mi.label"
                 class="menu-icon"/>
            <svg *ngIf="mi.iconHref?.includes('#')"
                 aria-hidden="true"
                 class="slds-icon slds-icon_small slds-icon-text-default menu-icon">
              <use [attr.xlink:href]="mi.iconHref"/>
            </svg>
            {{mi.label}}</a>
        </li>

      </ul>
    </div>
  </div>
</section>
<div class="slds-backdrop slds-backdrop_open"></div>
